/**
 * 跳转app私信南方号
 */

import { env } from "../config"
import getParamsFromUrl from "./getParamsFromUrl"
let openAppEnv = env === "pro" || !env ? "" : env
const urlParams = getParamsFromUrl()
const openApp = ({ address, title = document.title || "南方报业小记者", clickPosition }) => {
  const options = {
    id: 12,
    shareType: "share",
    title,
    isActivity: true,
    address,
    needClipboard: true,
    activityInfo: {
      activityId: urlParams.id
    },
    openAppBigDataInfo: {
      url: window.location.href,
      origin: 3,
      sourceTag: 12,
      clickPosition: clickPosition,
      itemId: urlParams.id,
      activityId: urlParams.id
    }
  }
  console.log('--getParamsFromUrl--',getParamsFromUrl(),clickPosition)
  window.OpenApp(options, openAppEnv)
}

export default openApp
